import PATH from "./Paths"

export function getMenu(isUserLoged){
    const defaultMain = [
        {
            label: 'Votação', 
            icon: 'pi pi-fw pi-home', 
            to: `${PATH.VOTACAO}`
        },
        {
            label: 'Seções', 
            icon: 'pi pi-fw pi-sitemap', 
            to: `${PATH.SECOES}`
        },       
        {
            label: 'Acompanhamento', 
            icon: 'pi pi-fw pi-th-large',
            to: `${PATH.ACOMPANHAMENTO}`
        },
        {
            label: 'Mapa', icon: 
            'pi pi-fw pi-map',
            to: `${PATH.MAPA}`
        }
    ]
    if (isUserLoged){
        return (defaultMain.concat(
            {
                label: 'Pendências', icon: 
                'pi pi-fw pi-book',
                to: `${PATH.PENDENCIAS}`
            })
        )
        

    }
    return defaultMain;
}